import 'jquery';
import 'bootstrap';

$(() => {
  // FAQ
  if ($('.schema-faq').length > 0) {
    $('.schema-faq-answer').addClass('collapse');
    $('.schema-faq-question').on('click', el => {
      const target = $(el.currentTarget);
      const answer = target.next('.schema-faq-answer');
      answer.collapse('toggle');
      target.toggleClass('faq-open');
    });
  }

  // Fiche sommaire
  if ($('#sommaire').length > 0) {
    let sommaire = '<ul>';
    $('h2').each((index, value) => {
      const link = index + '-' + $(value).text().toLowerCase().trim().replaceAll(/[^A-Za-z\\ ]/g, '').replaceAll(' ', '-');
      $(value).attr('id', link);
      if (index > 0) {
        sommaire += '<li><a href="#' + link + '" class="sommaire-link">' + index + '. ' + $(value).text() + '</a></li>';
      }

    });
    sommaire += '</ul>';
    $('#sommaire').append(sommaire);
    $('.sommaire-link').on('click', (event) => {
      if (+(event.currentTarget.attributes.href.value.substr(1, 1)) > 4) {
        $('#see-full-link').parent().parent().addClass('d-none');
        $('.fiche .content').removeClass('d-none');
        $('.easy-footnotes-wrapper').removeClass('d-none');
      }
    });
  }

  // Fiche full content
  if($('.fiche').length > 0) {
    $('.easy-footnotes-wrapper').addClass('d-none');
    $('#see-full-link').on('click', (event) => {
      event.preventDefault();
      $('#see-full-link').parent().parent().addClass('d-none');
      $('.fiche .content').removeClass('d-none');
      $('.easy-footnotes-wrapper').removeClass('d-none');
    });
    if (location.hash.indexOf('#comment') !== -1) {
      $('#see-full-link').parent().parent().addClass('d-none');
      $('.fiche .content').removeClass('d-none');
      $('.easy-footnotes-wrapper').removeClass('d-none');
    }
  }
});
